<template>
  <div id="cards" class="box">
    <vue-loading :active.sync="loading" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>
    <div class="row">
      <div class="column">
        <div class="row">
          <div class="column">

            <div>
              <transition name="fade" appear>
                <MetricGraph :metrics='metrics'
                    :name='"Throughput"'
                    :date='date'
                    :period='period'
                    v-on:updateMetric='updateMetric' />
              </transition>
            </div>

          </div>
        </div>
        <div class="row">
          <div class="column">
            <transition name="fade" appear>
              <div v-if="displayBoards.length > 0 && activeType == 'group'">
                <div class="card">
                  <h4 class="card-heading">Boards<span class="board-count">{{ displayBoards.length }}</span></h4>
                  <dl>
                    <template v-for="contract in displayBoards">
                      <dt @mouseover="hoverContract = contract.contract" @mouseout="hoverContract = null" class="contracts" v-bind:class="[ {'hover-contract': (hoverContract == contract.contract)},{'inactive-contract': (hoverContract != contract.contract)} ]" v-on:click="updateContract(contract.contract)" :key=contract.contract>{{ contract.contract }}</dt><dd :key="contract.contract + contract.count.toString()">{{ contract.count }}</dd>
                    </template>
                  </dl>
                </div>
              </div>
            </transition>

            <transition name="fade" appear>
              <div v-if="report.members.length > 0 && activeType == 'contract'">
                <div class="card">
                  <h4 class="card-heading">People</h4>
                  <dl>
                    <template v-for="member in report.members">
                      <dt @click="setActiveMember(member.member)" @mouseover="hoverMember = member.member" @mouseout="hoverMember = null" :key=member.member class="members-list" v-bind:class="[ {'active-member': (activeMember == member.member)},{'hover-member': (hoverMember == member.member && activeMember != member.member)},{'inactive-member': (activeMember != member.member && hoverMember != member.member)}]">{{ member.member }}</dt><dd :key="member.member + member.count.toString()">{{ member.count }}</dd>
                    </template>
                  </dl>
                </div>
              </div>
            </transition>

            <transition name="fade" appear>
              <div v-if="settings.cards.labels && report.labels && report.labels.length > 0 && activeType == 'contract'">
                <div class="card">
                  <h4 class="card-heading">Labels</h4>
                  <dl>
                    <template v-for="label in report.labels">
                      <dt @click="setActiveLabel(label.label)" @mouseover="hoverLabel = label.label" @mouseout="hoverLabel = null" :key=label.label class="label-list" v-bind:class="[ {'active-label': (activeLabel == label.label)},{'hover-label': (hoverLabel == label.label && activeLabel != label.label)},{'inactive-label': (activeLabel != label.label && hoverLabel != label.label)}]">{{ label.label }}</dt><dd :key="label.label + label.count.toString()">{{ label.count }}</dd>
                    </template>
                  </dl>
                </div>
              </div>
            </transition>

          </div>
          <div class="column">

            <transition name="fade" appear>
              <div v-if="displayMetrics && displayCards.length > 0">
                <div class="card">
                  <h4>Metrics</h4>
                  <dl>
                    <dt>Throughput</dt><dd>{{ displayCards.length }} {{ cardPlural(displayCards.length) }}</dd>
                  </dl>
                  <dl>
                    <dt>Avg top planned</dt><dd>{{ displayMetrics.queue }} {{ dayPlural(displayMetrics.queue) }}</dd>
                  </dl>
                  <dl>
                    <dt>Avg in progress</dt><dd>{{ displayMetrics.cycle }} {{ dayPlural(displayMetrics.cycle) }}</dd>
                  </dl>
                  <dl>
                    <dt>Unplanned</dt><dd>{{ Math.round(displayMetrics.unplanned / displayCards.length * 100) }} %</dd>
                  </dl>
                </div>
              </div>
            </transition>

            <transition name="fade" appear>
              <div v-if="report.members.length > 0 && activeType == 'group'">
                <div class="card">
                  <h4 class="card-heading">People</h4>
                  <dl>
                    <template v-for="member in report.members">
                      <dt @click="setActiveMember(member.member)" @mouseover="hoverMember = member.member" @mouseout="hoverMember = null" :key=member.member class="members-list" v-bind:class="[ {'active-member': (activeMember == member.member)},{'hover-member': (hoverMember == member.member && activeMember != member.member)},{'inactive-member': (activeMember != member.member && hoverMember != member.member)}]">{{ member.member }}</dt><dd :key="member.member + member.count.toString()">{{ member.count }}</dd>
                    </template>
                  </dl>
                </div>
              </div>
            </transition>

            <transition name="fade" appear>
              <div v-if="settings.cards.labels && report.labels && report.labels.length > 0 && activeType == 'group'">
                <div class="card">
                  <h4 class="card-heading">Labels</h4>
                  <dl>
                    <template v-for="label in report.labels">
                      <dt @click="setActiveLabel(label.label)" @mouseover="hoverLabel = label.label" @mouseout="hoverLabel = null" :key=label.label class="label-list" v-bind:class="[ {'active-label': (activeLabel == label.label)},{'hover-label': (hoverLabel == label.label && activeLabel != label.label)},{'inactive-label': (activeLabel != label.label && hoverLabel != label.label)}]">{{ label.label }}</dt><dd :key="label.label + label.count.toString()">{{ label.count }}</dd>
                    </template>
                  </dl>
                </div>
              </div>
            </transition>

          </div>
        </div>
      </div>
      <div class="column">
        <WorkCards :displayCards='displayCards' :period='period' :settings='settings' />
      </div>
    </div>
  </div>
</template>

<script>
import HTTP from '@/common/http'
import MetricGraph from '@/components/MetricGraph'
import WorkCards from '@/components/Cards/WorkCards'
import { mapGetters } from 'vuex'
import VueLoading from 'vue-loading-overlay'

export default {
  components: {
    MetricGraph,
    WorkCards,
    VueLoading
  },
  props: [
    'id'
  ],
  data () {
    return {
      metrics: [],
      report: {
        period: null,
        date: null,
        cards: [],
        members: [],
        labels: [],
        contracts: [],
        queue: null,
        cycle: null
      },
      interval: '',
      activeMember: null,
      hoverMember: null,
      activeLabel: null,
      hoverLabel: null,
      hoverContract: null,
      date: null,
      period: 'week',
      sentimentThreshold: 80,
      loading: false
    }
  },
  computed: {
    ...mapGetters([
      'settings',
      'activeType'
    ]),
    dateOrMetrics () {
      return [this.date, this.metrics].join()
    },
    displayCards () {
      if (this.activeMember) {
        let member = this.report.members.find(obj => { return obj.member === this.activeMember })
        return member.cards
      } else if (this.activeLabel) {
        let label = this.report.labels.find(obj => { return obj.label === this.activeLabel })
        return label.cards
      } else {
        return this.report.cards
      }
    },
    displayBoards () {
      if (this.activeMember) {
        let member = this.report.members.find(obj => { return obj.member === this.activeMember })
        return member.contracts
      } else if (this.activeLabel) {
        let label = this.report.labels.find(obj => { return obj.label === this.activeLabel })
        return label.contracts
      } else {
        return this.report.contracts
      }
    },
    displayMetrics () {
      if (this.activeMember) {
        let member = this.report.members.find(obj => { return obj.member === this.activeMember })
        return member
      } else if (this.activeLabel) {
        let label = this.report.labels.find(obj => { return obj.label === this.activeLabel })
        return label
      } else {
        return this.report
      }
    }
  },
  created: function () {
    this.getMetrics(true, true)
    this.interval = setInterval(function () {
      this.getMetrics(false, false)
    }.bind(this), 18000)
  },
  destroyed: function () {
    clearInterval(this.interval)
  },
  watch: {
    id: function () {
      this.report = {
        period: null,
        date: null,
        cards: [],
        members: [],
        contracts: [],
        queue: null,
        cycle: null
      }
      this.getMetrics(true, false)
      this.activeMember = null
      this.activeLabel = null
      this.hoverContract = null
    },
    period: function () {
      this.getMetrics(false, true)
      this.activeMember = null
      this.activeLabel = null
    },
    dateOrMetrics: {
      handler: function () {
        this.getCards()
      },
      deep: true
    },
    report: {
      handler: function () {
        if (!this.report.members.map(members => members.member).includes(this.activeMember)) {
          this.activeMember = null
        }
        if (!this.report.labels.map(labels => labels.label).includes(this.activeLabel)) {
          this.activeLabel = null
        }
      },
      deep: true
    }
  },
  methods: {
    formatTimestamp: function (timestamp, period) {
      let date = new Date(timestamp * 1000)
      let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Octr', 'Nov', 'Dec']
      let weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      let day = date.getDate()
      let weekday = weekdays[date.getDay()]
      let month = months[date.getMonth()]
      let hours = date.getHours()
      let minutes = '0' + date.getMinutes()
      if (period === 'week') {
        return weekday + ' ' + hours + ':' + minutes.substr(-2)
      } else {
        return month + ' ' + day + ', ' + hours + ':' + minutes.substr(-2)
      }
    },
    formatTime: function (time) {
      if (time > 0) {
        let seconds = time
        let minutes = Math.floor(seconds / 60)
        let hours = Math.floor(minutes / 60)
        if (hours > 0) {
          return hours + 'h'
        } else if (minutes > 0) {
          return minutes + 'm'
        } else {
          return seconds + 's'
        }
      } else {
        return ''
      }
    },
    defaultZero: function (value) {
      if (value) {
        return value
      } else {
        return 0
      }
    },
    cardPlural: function (val) {
      if (val === 1) {
        return 'card'
      } else {
        return 'cards'
      }
    },
    dayPlural: function (val) {
      if (val === 1) {
        return 'day'
      } else {
        return 'days'
      }
    },
    dots: function (days) {
      let output = []
      if (days >= 5) {
        let dots = Math.floor(days / 5)
        output.push(...Array(dots).fill('<svg height="6" width="10"><circle cx="3" cy="3" r="3" fill="#f070a1"><title>' + days + '</title></circle></svg>'))
      } else {
        let dots = days
        output.push(...Array(dots).fill('<svg height="6" width="10"><circle cx="3" cy="3" r="3" fill="#77a6f7"><title>' + days + '</title></circle></svg>'))
      }
      return output
    },
    getMetrics: function (showLoading, setDate) {
      this.loading = showLoading
      HTTP.get(`/cards/metrics/${this.activeType}/${this.id}/${this.period}`)
        .then((response) => {
          this.metrics = response.data['metrics']
          if (setDate) {
            this.date = response.data['metrics'][11]['date']
          }
        })
        .catch((error) => {
          this.metrics = []
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: `Failed to get card metrics : ${msg}`
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    getCards: function () {
      HTTP.get(`/cards/cards/${this.activeType}/${this.id}/${this.period}/${this.date}`)
        .then((response) => {
          this.report = response.data
        })
        .catch((error) => {
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: `Failed to get card report : ${msg}`
          })
        })
    },
    updateContract: function (contract) {
      this.$store.dispatch('SET_ACTIVE', contract)
    },
    updateMetric: function (event) {
      switch (event.eventType) {
        case 'date':
          this.date = event.data.date
          break

        case 'period':
          this.period = event.data.period
          break

        default:
          console.log(event)
          break
      }
    },
    setActiveMember: function (member) {
      if (this.activeMember === member) {
        this.activeMember = null
      } else {
        this.activeLabel = null
        this.activeMember = member
      }
    },
    setActiveLabel: function (label) {
      if (this.activeLabel === label) {
        this.activeLabel = null
      } else {
        this.activeMember = null
        this.activeLabel = label
      }
    }
  }
}
</script>
<style scoped src='../assets/stylesheet/cards.css'></style>



// WEBPACK FOOTER //
// src/views/Cards.vue